import { CircularProgress } from '@mui/material';
import UnitDataTable from 'app/components/DataTable/unit/UnitDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';


const ListUnit = () => {


    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const allAuthorizedUnits = useSelector(state => state.auth.allAuthorizedUnits);


    useEffect(() => {
        const getAPI = async () => {
            setLoading(true);

            setData(allAuthorizedUnits);

            setLoading(false);
        }
        getAPI()
    }, [])




    const columnData = [
        { id: 'inst', align: 'center', disablePadding: false, label: "Kurum" },
        { id: 'name', align: 'center', disablePadding: true, label: "Kurul/Kol/Komisyon Adı" },
        { id: 'uploadFileStatus', align: 'center', disablePadding: true, label: "Rapor Yükleme Zorunluluğu" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler" }
    ];


    return (
        <React.Fragment>

            <>
                <LoadingPopUp open={loading} />
                {!loading && <UnitDataTable mainData={data} column={columnData} pageTitle="Kurul/Kol/Komisyon Listesi" />}
            </>



        </React.Fragment>
    );
};

export default ListUnit;